import * as React from 'react';
import { createComponent } from '@lit/react';
import { UniversalUserDropdownLoaderWC } from './universal-user-dropdown-loader.wc';

export const UniversalUserDropdownLoader = createComponent({
  tagName: UniversalUserDropdownLoaderWC.tagname,
  elementClass: UniversalUserDropdownLoaderWC,
  react: React,
});
